export default {
  methods: {
    focusFirstError(e) {
      const el = e.target

      setTimeout(() => {
        const firstErrorEl = el.querySelector('.has-error')
        const firstField = firstErrorEl?.querySelector(
          'input, select, textarea'
        )
        firstField?.focus()
      }, 200)
    },
    validate(e) {
      e.preventDefault()
      e.stopPropagation()

      const isValid = this.$children
        .filter((c) => typeof c.validate !== 'undefined')
        .map((c) => c.validate())
        .every((res) => res)

      if (isValid) {
        e.target.submit()
      }

      this.focusFirstError(e)

      return false
    },
  },
}
